import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Transformation() {
  return <section className="py-24 px-6 bg-slate-900 border-t border-slate-800 text-center" data-id="element-249">
      <div className="max-w-3xl mx-auto" data-id="element-250">
        <FadeIn data-id="element-251">
          <h2 className="text-3xl font-bold text-white mb-8" data-id="element-252">
            Lo que quiero que pase esta noche
          </h2>
          <div className="space-y-6 text-xl md:text-2xl" data-id="element-253">
            <p className="text-slate-400" data-id="element-254">
              Quiero que te despiertes… y en vez de pensar: <br data-id="element-255" />
              <span className="text-red-400 line-through decoration-red-400/50" data-id="element-256">
                "Ya valí."
              </span>
            </p>
            <p className="text-white font-medium" data-id="element-257">
              Pienses: <br data-id="element-258" />
              <span className="text-amber-400 text-3xl md:text-4xl block mt-4" data-id="element-259">
                "Ok. Ya sé qué hacer."
              </span>
            </p>
          </div>
          <p className="mt-8 text-slate-400" data-id="element-260">Ese cambio te devuelve poder.</p>
        </FadeIn>
      </div>
    </section>;
}